"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fetch = require("@iyunbao/fetch");

var _config = _interopRequireDefault(require("./config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _fetch.setServices)(_config.default.API);
var fetch = new _fetch.FetchAPI(); // 开启替换域名

fetch.setOptions({
  replaceHostUrl: true
});
var _default = fetch;
exports.default = _default;